module.exports = __webpack_public_path__ + "img/eurorail-logo.d98ec292.png";